export const TRANSFORMATION_LABELS = {
  'MoM %': 'Month over month change (%)',
  'QoQ %': 'Quarter over quarter change (%)',
  'YoY %': 'Year over year change (%)',
  MA3: '3 month moving average',
  MA6: '6 month moving average',
  MA12: '12 month moving average',
  annualized: 'Annualized rate',
  '': 'Original value (no variation)',
  null: 'Original value (no variation)',
}

export const TRANSFORMATION_SHORT_LABELS = {
  'MoM %': 'MoM (%)',
  'QoQ %': 'QoQ (%)',
  'YoY %': 'YoY (%)',
  MA3: 'MA3',
  MA6: 'MA6',
  MA12: 'MA12',
  annualized: 'Annualized',
  '': 'None',
  null: 'None',
}

export const TRANSFORMATION_HELP = {
  'MoM %': {
    label: 'MoM (%)',
    description: 'Percentage change in a variable compared with the previous month.',
  },
  'QoQ %': {
    label: 'QoQ (%)',
    description: 'Percentage change in a variable compared with the previous quarter.',
  },
  'YoY %': {
    label: 'YoY (%)',
    description: 'Percentage change in a variable compared with the same period of the previous year.',
  },
  MA3: {
    label: 'MA3',
    description: 'Three-period moving average of a variable.',
  },
  MA6: {
    label: 'MA6',
    description: 'Six-period moving average of a variable.',
  },
  MA12: {
    label: 'MA12',
    description: 'Twelve-period moving average of a variable.',
  },
  annualized: {
    label: 'Annualized',
    description: 'Value expressed at an annual rate. For quarterly flow series, this is calculated by multiplying the quarterly value by four.',
  },
}

export const getTransformationLabel = value => (
  TRANSFORMATION_LABELS[value] || value || TRANSFORMATION_LABELS['']
)

export const getTransformationShortLabel = value => (
  TRANSFORMATION_SHORT_LABELS[value] || value || TRANSFORMATION_SHORT_LABELS['']
)

export const getTransformationHelp = value => (
  TRANSFORMATION_HELP[value] || {
    label: getTransformationShortLabel(value),
    description: getTransformationLabel(value),
  }
)
